
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/pediatric-intensive-care",
      function () {
        return require("private-next-pages/special/pediatric-intensive-care/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/pediatric-intensive-care"])
      });
    }
  